import { css } from "@emotion/react";

export const invitationDrawerStyles = css`
  .overflow-hidden {
    overflow: hidden;
  }
`;
